import { render, staticRenderFns } from "./MyAttendanceToday.vue?vue&type=template&id=22d2421e&scoped=true"
import script from "./MyAttendanceToday.vue?vue&type=script&lang=js"
export * from "./MyAttendanceToday.vue?vue&type=script&lang=js"
import style0 from "./MyAttendanceToday.vue?vue&type=style&index=0&id=22d2421e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d2421e",
  null
  
)

export default component.exports